import { createHandlerChainRunner, Handler, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import { BillToModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";
import {
    AddressValidationParameter,
    AddressValidationResult,
    validateAddress,
    ValidationAddressModel,
} from "@SupplyLand/Services/AddressValidationService";
import { CustomActions } from "@SupplyLand/Store/Data/SupplyLand/SupplyLandReducer";
import { DispatchProp } from "react-redux";

interface OwnProps {
    apiResult: AddressValidationResult;
    address: ShipToModel;
    error?: unknown;
}

type Props = OwnProps & DispatchProp<CustomActions>;

type HandlerType = Handler<ShipToModel, Props>;

export const PopulateApiParameter: HandlerType = props => {
    const { ...address } = props.parameter;
    props.address = address;
};

export const DispatchAction: HandlerType = props => {
    if (!props.error) {
        props.dispatch({
            type: "Pages/CheckoutShipping/SetShippingAddress",
            address: props.address,
        });
        props.dispatch({
            type: "Pages/OnePageCheckout/SetShippingAddress",
            address: props.address,
        });
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (props.error) {
        // markSkipOnCompleteIfOnErrorIsSet(props);
        // props.parameter.onError?.(props.error);
    }
};

export const chain = [PopulateApiParameter, DispatchAction, ExecuteOnSuccessCallback, ExecuteOnErrorCallback];

const updateShippingAddressHandler = createHandlerChainRunner(chain, "updateShippingAddressHandler");

export default updateShippingAddressHandler;
